import { EntityType } from '../comment';
import { CompanyEntity } from '../common/entity';
import { TableColumn } from './TableColumn';

export class TableSettings<C> extends CompanyEntity {
  userId?: string;
  type!: EntityType;
  parentType?: EntityType;
  columns: TableColumn<C>[] = [];

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}
